import { EDITOR_TEXT_BOX_ITEM_TYPE } from 'utils/editor-text-box/editorTextBoxAdapter'
import zLayers from 'utils/styling/zLayers'

export const MIN_ITEM_RESIZE_PX = 20

const base = {
  x: 15,
  y: 15,
  z: zLayers.content,
  height: 200,
  width: 200,
  properties: {},
  manipulated: {
    userInserted: true,
    initialLoad: true,
  },
  edits: {},
}

const editorTextBoxStub = {
  type: EDITOR_TEXT_BOX_ITEM_TYPE,
}

export const itemTypes = {
  image: {
    ...base,
    type: 'image',
    maintainAspectRatio: true,
    image: {
      url: '',
      editedUrl: '',
      edits: {},
    },
  },
  designAsset: {
    ...base,
    type: 'image',
    assetLocked: true,
    maintainAspectRatio: true,
    image: {
      url: '',
      editedUrl: '',
      edits: {},
    },
  },
  text: {
    ...base,
    type: 'text',
    z: zLayers.content,
    height: 17,
    text: {
      value: 'New Text Box',
    },
  },
  shape: {
    ...base,
    type: 'shape',
    edits: {
      backgroundColor: '#FFFFFF',
      opacity: '1',
    },
  },
  line: { ...base, type: 'line', height: 2 },
  editorTextBox: editorTextBoxStub,
  qrCode: {
    ...base,
    type: 'qrCode',
    height: 200,
    width: 200,
    edits: {
      opacity: '1',
    },
  },
}

export default itemTypes
